import type React from 'react';

import type { GetUsersParams } from '@vlabs/api/artemy/model';

import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

import { useUserListFilters } from './useUserListPageFilters';

function getActiveFiltersCount(filters: GetUsersParams): number {
  let count = 0;

  if (filters.user_ids !== undefined) count += 1;
  if (filters.email !== undefined) count += 1;
  if (filters.full_name !== undefined) count += 1;
  if (filters.role_id !== undefined) count += 1;
  if (filters.department_id !== undefined) count += 1;
  if (filters.last_login_at__lt !== undefined || filters.last_login_at__gte !== undefined) count += 1;
  if (filters.create_time__lt !== undefined || filters.create_time__gte !== undefined) count += 1;

  return count;
}

function UserListFilterMenuButton(): React.JSX.Element {
  const { filters } = useUserListFilters();

  return (
    <FilterMenuButton
      filtersCount={getActiveFiltersCount(filters)}
    />
  );
}

export { UserListFilterMenuButton };
